import { SettingsFieldSelect } from 'apps/builder/components/settings/modal/shared'

export const CalculationField = ({ type, guid, label, keyField }) => (
  <div className="settings--row no-border">
    <SettingsFieldSelect
      guid={guid}
      label={label}
      keyField={keyField}
      type={type}
    />
  </div>
)
